export const canEditProfile = (currentUid, profileUid) =>
  Boolean(currentUid) && currentUid === profileUid;
